import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class EbUnitSelectorService {
  private unitChanged$ = new Subject<boolean>()
  private unitValue: string

  constructor() {
    this.unitChanged$.next(false)
  }

  unitChanged() {
    this.unitChanged$.next(true)
  }

  getUnitChanged(): Subject<boolean> {
    return this.unitChanged$
  }

  setUnitValue(unit) {
    this.unitValue = unit
  }

  getUnitValue() {
    return this.unitValue
  }
}
